import React, { useState, useEffect } from "react";
import "./style.css";
import axios from "axios";

const Weather = () => {
  const api_key = "16ad003bda13913487078f36279ab444";
  const [search, setSearch] = useState("Lahore");
  const [city, setCity] = useState({
    name: "Lahore",
    temprature: 200,
    mintemp: 150,
    maxtemp: 200,
  });

  const changed = (event) => {
    setSearch(event.target.value);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const json_res = await axios.get(
          `https://api.openweathermap.org/data/2.5/weather?q=${search}&appid=${api_key}`
        );
        let name = json_res.data.name;
        let temprature = json_res.data.main.temp;
        let mintemp = json_res.data.main.temp_min;
        let maxtemp = json_res.data.main.temp_max;
        let weather_des = json_res.data.weather[0].description;
        let weather_img = json_res.data.weather[0].icon;
        let resdict = {
          name: name,
          temprature: Math.round(temprature - 273.15),
          mintemp: Math.round(mintemp - 273.15),
          maxtemp: Math.round(maxtemp - 273.15),
          weather_des: weather_des,
          weather_img: weather_img,
        };

        setCity(resdict);
      } catch (error) {
        console.log(error);
      }
    }
    fetchData();
  }, [search, setSearch]);
  return (
    <div className="main_div">
      <div className="inner_div">
        <h1 className="head-logo">
          Weather <span>Now</span>
        </h1>
        <input type={"text"} onChange={changed} value={search}></input>
        <br></br>

        <img
          className="weather-img"
          src={`http://openweathermap.org/img/wn/${city.weather_img}.png`}
          alt="weather-img"
        ></img>
        <h2>{city.weather_des}</h2>
        <h1>
          {city.temprature}
          <span className="celcius-circle-h1">o</span> C{" "}
        </h1>
        <p>
          <span style={{ marginRight: "10px" }}>
            Min : {city.mintemp}
            <span className="celcius-circle">o</span> C{" "}
          </span>
          |
          <span style={{ marginLeft: "10px" }}>
            Max : {city.maxtemp}
            <span className="celcius-circle">o</span> C
          </span>
        </p>
        <h1>{city.name}</h1>
      </div>
    </div>
  );
};

export default Weather;
